import NavBar from './app/NavBar';
import AppRoutes from './app/AppRoutes';

//  McCool Math app components 
function App() {
  return (
    <div className="App"> 
        <NavBar />
        <AppRoutes />
    </div>
  );
}

export default App;
